import CardHoc from "../UI/CardHoc";
import Button from "../common/Button";
import LazyLoad from "react-lazyload";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { BsFillPlayCircleFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import notAvailable from "../../assets/notAvailable.png";
import { addCartItem } from "../../store/slices/cartSlice";

const HomeCard = (props) => {
  const dispatch = useDispatch();
  const [levels, setLevels] = useState([]);
  const [comboActs, setComboActs] = useState([]);
  const acts = useSelector((state) => state.activities?.activities);
  const combos = useSelector((state) => state.activities?.combos);

  useEffect(() => {
    if (props?.activities) {
      let newArr = props.activities.map((act) =>
        [...acts, combos].find((val) => {
          return act === val._id;
        }),
      );
      // eslint-disable-next-line array-callback-return
      newArr = newArr.map((e) => {
        if (e?.name !== undefined) return e?.name;
      });
      setComboActs(newArr);
    }
    if (props?.variants) setLevels(props.variants);
  }, [setComboActs, props.activities, acts, combos, props.body, props.variants]);

  const handleChange = async (variantPackage) => {
    let data = {};
    const id = Date.now().toString(36) + Math.random().toString(36).substr(2);
    if (props?.person || variantPackage?.noOfPerson > 1) {
      data = {
        activityId: variantPackage?._id ? variantPackage?._id : props.id,
        activity_date: null,
        person: 1,
        numberOfPerson: variantPackage?.noOfPerson ? variantPackage?.noOfPerson : props.person,
        total_item_price: variantPackage?.price ? variantPackage?.price : props.price,
        activity: {
          image_url: props.image,
          name: variantPackage?.variantType
            ? `${props.name}: ${variantPackage?.variantType}`
            : props.name,
          activity_price: variantPackage?.price ? variantPackage?.price : props.price,
          activities: comboActs,
        },
        _id: id,
      };
    } else {
      data = {
        activityId: variantPackage?._id ? variantPackage?._id : props.id,
        activity_date: null,
        person: 1,
        total_item_price: variantPackage?.price ? variantPackage?.price : props.price,
        activity: {
          image_url: props.image,
          name: variantPackage?.variantType
            ? `${props.name}: ${variantPackage?.variantType}`
            : props.name,
          activity_price: variantPackage?.price ? variantPackage?.price : props.price,
        },
        _id: id,
      };
    }
    dispatch(addCartItem(data));
    toast.success("Added to cart", { position: "top-center" });
  };
  return (
    <CardHoc parentClassName="flex-1" className="min-w-[18rem] relative">
      <div className="cursor-pointer">
        {!props.status && (
          <div className="absolute h-full w-full z-10 cursor-not-allowed">
            <img src={notAvailable} alt="" className="object-contain h-full w-full" />
          </div>
        )}
      </div>
      <div>
        {/* <Link to={`/activity/${props.slug}`}> */}
        <figure className={`min-w-[200px] ${!props.status ? `opacity-50` : `opacity-100`}`}>
          <div className="relative h-60">
            {!props.youtubeUrl ? (
              <>
                <video
                  poster={props?.videoThumbnails}
                  src={props?.image}
                  className="w-full h-full object-cover rounded-t-xl brightness-50"
                  draggable={false}
                ></video>
                <span
                  className="absolute h-12 w-12 top-[45%] left-[45%] text-white-900 hover:scale-110 opacity-75 hover:opacity-100 hover:cursor-pointer"
                  onClick={() => props.setShowVideoModal({ project: true, video_url: props.image })}
                >
                  <BsFillPlayCircleFill className="h-full w-full" />
                </span>
              </>
            ) : (
              <>
                <div className="relative h-60 min-w-[200px]">
                  <LazyLoad>
                    <iframe
                      height="240"
                      className="overflow-hidden w-full rounded-t-xl"
                      src={
                        props.youtubeUrl &&
                        `${props?.youtubeUrl}?controls=0&showinfo=0&modestbranding=1`
                      }
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      donotallowfullscreen="true"
                    ></iframe>
                  </LazyLoad>
                </div>
                <div
                  className="absolute z-100 cursor-none lg:cursor-pointer w-full rounded-t-xl top-0 h-60 min-w-[200px]"
                  onClick={() =>
                    props.setShowVideoModal({ project: true, video_url: props?.youtubeUrl })
                  }
                ></div>
              </>
            )}
          </div>
        </figure>
        {/* </Link> */}
        <figcaption className="relative p-3 ">
          {levels.length > 0 ? null : (
            <p className="text-lg font-semibold md:text-md absolute -top-[1.15rem] right-6 px-4 py-1 bg-primary text-white-900 rounded text-left cursor-pointer">
              ₹ {props.price}
            </p>
          )}
          <Link to={`/activity/${props.slug}`}>
            <p className="md:text-lg font-bold mt-2 hover:text-gray-700 hover:cursor-pointer">
              {props.name.length > 25 ? `${props.name.substr(0, 25)}...` : props.name}
            </p>
          </Link>
          <p className="text-sm md:text-md text-black-500">
            {props?.person ? `Min. Number of Person: ${props.person}` : ""}
          </p>
          <p className="text-sm md:text-md text-gray-400">
            {comboActs.length > 0
              ? comboActs.map((act, index) => {
                  return act + `${index === comboActs.length - 1 ? "." : ", "}`;
                })
              : levels?.length > 0
              ? levels?.map((variantPackage, i) => (
                  <span className="flex items-center justify-between my-2" key={i}>
                    {variantPackage?.variantType}: ₹{variantPackage.price}
                    <Button
                      text="Add to cart"
                      className="px-2 py-1"
                      handler={() => handleChange(variantPackage)}
                    />
                  </span>
                ))
              : props.body}
          </p>
          {levels.length > 0 ? null : (
            <div className="text-sm md:text-md flex flex-row-reverse justify-between mt-3 items-center text-grey mb-2">
              <span className="flex items-center">
                <FaMapMarkerAlt className="mr-1" />
                <p className="font-bold">{props.location}</p>
              </span>
              <div onClick={handleChange}>
                <Button text="Add to Cart" className="px-4 py-1.5 z-20" />
              </div>
            </div>
          )}
        </figcaption>
      </div>
    </CardHoc>
  );
};

export default HomeCard;
